import * as React from 'react';
import './index.css';
import { getAttachments } from '@/src/components/HomePage/ContentItems';
// import ImgBottomLabel from "@/src/components/HomePage/ImgBottomLabel";
import { isSupportTransition } from '@/src/utils';
import { buildUrl } from '@/src/utils/buildUrl';
import { cloneDeep } from 'lodash';
import ImgOverlay from '@components/HomePage/ImgOverlay';
import ShopDishes from '../dishes';
import { ShopStatus } from '../constant';
import { ShopCardWithDishesDataType, DishDataType } from '../interface';

type IProps = {
  layoutInfo?: any;
  data: ShopCardWithDishesDataType;
  lxReportOnClick?: () => void;
  productOnClick?: (data: DishDataType, index: number) => void;
  productOnScrollEnd?: (x: number) => void;
}

interface State {
//   imgTagWidth: number,
}

const WMRouter = Mach.requireModule('Router');
// const imageWidth = 120;

export default class ShopCard extends React.PureComponent<IProps, State> {
  // customItemsConfigs: any;

  sharedElementImageRef: any = null;

  constructor(props) {
    super(props);
    // this.state={
    //   imgTagWidth: 1,
    // }
  }

  extraCardData = {
    shouldDynamicTagsTwoLines: true
  }

  changeExtraCardData = (extraCardData) => {
    this.extraCardData = {
      ...this.extraCardData,
      ...extraCardData
    };
  }

  gotoDetailPage() {
    if (this.props.lxReportOnClick) {
      this.props.lxReportOnClick();
    }
    const shopInfoResponse = { ...(this.props.data?.shopInfoResponse || {}), checkList: Boolean(this.props.data?.shopInfoResponse) };
    const hasTransitionPic = shopInfoResponse?.logoUrl;
    const supportTransition = isSupportTransition(Mach.env.bundleName) && hasTransitionPic;
    const transition = supportTransition ? 1 : 0;
    if (supportTransition) {
      this.sharedElementImageRef?.didSelectedImageView?.();
    }
    WMRouter.navigateTo(buildUrl(this.props.data?.scheme, { transition }), { shopInfoResponse }, () => {});
  }

  getCustomContentItemStyle = ({ type }: {type: string;}) => {
    if (type === 'shopName') {
      return {
        maxLines: 2
      };
    }
    if (type === 'dynamicTags') {
      return {
        maxLines: 1
      };
    }
    return {
      maxLines: 1
    };
  }

  renderContent = (content: any) => {
    let featureValue; let
      closeLabelValue; let
      pickUpIconValue;
    let modifiedContent = cloneDeep(content);
    modifiedContent = modifiedContent.map((row: any[]) => row.map((item) => {
      if (item.type === 'featureLabel') {
        featureValue = item.data.featureLabel;
      } else if (item.type === 'pickUpIcon') {
        pickUpIconValue = item.data.pickUpIcon;
      }
      if (item.type === 'shopCloseLabel') {
        closeLabelValue = item.data.shopCloseLabel;
      }
      if (item.type === 'shopName') {
        if (!closeLabelValue) {
          item.data.featureLabel = featureValue;
          item.data.pickUpIcon = pickUpIconValue;
        }
        item.data.closeLabel = closeLabelValue;
      }
      return item;
    }));
    return (
      <view style={{ marginLeft: 8, marginTop: -8 }}>
        {modifiedContent.length > 0 && (
          <view className="procuct-content-container">
            {modifiedContent.map((warp, line) => (warp?.length > 0 ? (
              <view key={line} className="procuct-content-item-container">
                {warp?.map((item, index) => {
                  const attachmentData = getAttachments(item);
                  const customStyles = this.getCustomContentItemStyle({
                    type: item.type
                  });
                  const lastAttachmentData = getAttachments(warp?.[Number(index) + 1]);
                  const showHalfOpacity = (item?.type !== 'outOfRangeInfo') && (this.props.data?.shopStatus?.hasOutOfRange === 1);
                  if (attachmentData) {
                    return (
                      <view style={{ opacity: showHalfOpacity ? 0.5 : 1 }}>
                        <attachmentData.attachment
                          key={`item.type_${line}_${index}`}
                          data={item?.data}
                          line={line}
                          index={index}
                          itemKey={item?.type}
                          hasLastItem={lastAttachmentData !== undefined}
                          style={customStyles}
                        />
                      </view>
                    );
                  }
                  return null;
                })}
              </view>
            ) : null))}
          </view>
        )}
      </view>
    );
  }
  render() {
    const { data, layoutInfo } = this.props;
    // const deliveryTagImg = data?.imgBottomContent?.promotionIconUrl;
    // const imgBottomLabel = data?.imgBottomLabel;
    const subCards = data?.subCards;
    const deliveryTagText = data?.imgBottomContent?.promotionText;
    // const showDeliveryImgTag = (!data?.shopStatus?.shopStatusDesc) && deliveryTagText && deliveryTagImg;
    // const {imgTagWidth} = this.state;
    const shopContentVerticalData = data.content || [];
    const shopHeadImageUrl = data?.shopInfoResponse?.logoUrl;
    const height = Math.floor(Mach.env?.screenWidth * (9 / 16));
    // const shopHeadImageCacheCDNParam = `${Mach.env.screenWidth * Mach.env.scale}.${height * Mach.env.scale}.100`
    // const renderSharedElementImage = isSupportTransition(Mach.env.bundleName) && shopHeadImageUrl;
    const showRestBg = data?.shopStatus?.shopStatusCode === ShopStatus.CLOSED
        || data?.shopStatus?.shopStatusCode === ShopStatus.OFFLINE
        || data?.shopStatus?.shopStatusCode === ShopStatus.OUT_OF_RANGE;
    return (
      <view>
        {(
          <view className="root-container" style={{ marginLeft: layoutInfo?.margin_left || 0, marginRight: layoutInfo?.margin_right || 0 }}>
            <view
              key="card" style={{
                flexDirection: 'column', paddingLeft: 0, paddingTop: 12, paddingRight: 0, paddingBottom: 12
              }}
            >
              <view
                className="itemContainer" onClick={() => {
                  this.gotoDetailPage();
                }}
              >
                {/*图片+店铺信息区*/}
                <view style={{ flexDirection: 'row', marginRight: 8, marginLeft: 12 }}>
                  {/*商家主图*/}
                  <view className="picturePart">
                    {/*{renderSharedElementImage ? <shared-element-image*/}
                    {/*  ref={(ref) =>{*/}
                    {/*    this.sharedElementImageRef = ref;*/}
                    {/*  }}*/}
                    {/*  cdnOptimizationSize= {shopHeadImageCacheCDNParam}*/}
                    {/*  className="interactive-transition-image"*/}
                    {/*  resizeMode={'scaleToFill'}*/}
                    {/*  placeholder="assets://placeholder/icon_placeholder_16:9.png"*/}
                    {/*  src={*/}
                    {/*    shopHeadImageUrl*/}
                    {/*  }*/}
                    {/*  error="assets://placeholder/icon_placeholder_16:9.png"*/}
                    {/*/> : null}*/}
                    <image
                      className="itemImage"
                      resizeMode="aspectFill"
                      placeholder="assets://placeholder/icon_placeholder_1:1.png"
                      src={
                        // eslint-disable-next-line
                        data?.shopMainPicUrl != null && data?.shopMainPicUrl !== ''
                          ? data?.shopMainPicUrl
                          : 'assets://placeholder/icon_placeholder_1:1.png'
                      }
                      error="assets://placeholder/icon_placeholder_1:1.png"
                    />
                    {/*营业状态：营业中-3；休息中-4*/}
                    {data?.imgOverlay
                      ? <ImgOverlay imgOverlay={data?.imgOverlay} shopStatus={data?.shopStatus} isSmallCard />
                      : (showRestBg && <view className="restBg" />)}
                  </view>

                  {/* 店铺信息区 */}
                  {this.renderContent(shopContentVerticalData)}
                </view>
              </view>
              {(subCards || []).length ? (
                <ShopDishes
                  subCards={subCards}
                  onClick={this.props.productOnClick}
                  onScrollEnd={this.props.productOnScrollEnd}
                />
              ) : null}
            </view>
          </view>
        )}
      </view>
    );
  }
}
